import Vue from "vue";
import config from "@/config";
import errorTags from "@/errorTags";
import router from "@/router";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    language: "en",
    _loading: {
      login: false,
      logout: false,
      forgotPassword: false,
      memberSignUp: false,
      memberTacValidate: false,
      memberRenewTac: false,
      updatePassword: false,
      profileUpdate: false,
      memberAddBank: false,
      memberAddEwallet: false,
      setDefaultBank: false,
      memberBankTac: false,
      depositOfaPay: false,
      manualDeposit: false,
      getPromotionStatus: false,
      addWithdrawTicket: false,
      getInbox: false,
      claimInbox: false,
      launchGame: false,
      getQuestion: false,
      submitReview: false,
      getSurveyList: false,
      mayaPay: false,
      htPay:false,
      aiPay:false,
      rmPay:false,
      gopayGcash:false,
      gopayMaya:false,
      dgpayGcash:false,
      dgpayGcashqr: false,
      dgpayMaya:false,
      cloudPay:false,
      topPay:false,
      anfuPay:false,
      shunfapayGcash: false,
      shunfapayMaya: false,
      worldPay:false,
      rgPay: false,
      wcPay: false,
      goldPay:false,
      xftgCash:false,
      xftUsdt:false,
      masayaPay: false,
      xyPay:false,
      tygPay:false,
      ctPay:false,
      innPay:false,
      rkPay:false,
      ezPay:false,
      sgPay:false,
      goldPay2:false,
      rkPaygcash: false,
      rkPaygcashQr:false,
      swPaygcash: false,
      swPaygcashQr:false,
      getCouponDetails: false,
      updateEmail: false,
      getBankingMode: false,
      getSocialList: false,
      getRtplist: false,
      getStatement: false,
      getMemberGameResult: false,
      getRebate: false,
      getRebateDownline: false,
      getTurnoverProvider:false,
      claimRebate: false,
      claimRebateDownline:false,
      getRefereeList: false,
      launchEpic: false,
      launchEpic2:false,
      launchLive22:false,
      launchAwc: false,
      launchJili:false,
      launchFc: false,
      launchSabong: false,
      launchIronclaw:false,
      launchEvo: false,
      launchWbet: false,
      launchCq9: false,
      launchHabanero: false,
      launchPps:false,
      launchPpc:false,
      launchLaunchOne:false,
      launchYgr: false,
      launchWow:false,
      launchTbl:false,
      makeBet: false,
      getBetList: false,
      getRealTimeTrans:false,
      getRebateChart: false,
      getXchangeRate: false,
      getStreamLink: false,
      getTopgame:false,
      getClaimedTickets: false,
      getSpadeResult: false,
      getPgsResult: false,
      getPpsResult: false,
      getJokerResult: false,
      // getEpicResult: false,
      getHbResult: false,
      getLive22Result: false,
      getEpic2Result: false,
      getPpsResult:false,
      getCq9Result:false,
      getHabaneroResult:false,
      getPpcResult:false,
      getAwcResult: false,
      getJiliResult: false,
      getFcResult:false,
      getEvoResult:false,
      getLaunchoneResult:false,
      getYgrResult:false,
      getWowResult:false,
      getProviderGameOfflist: false,
      getTokenBalance:false,
      getSlideBanner:false,
      getAnnBanner:false,
      getPromoBanner: false,
      getSeo: false,
      mbTacLogin: false,
      mbNewLogin: false,
    },
    transferDetails: [],
    promoDetails: [],
    adjustmentDetails: [],
    refereeCount:[],
    betList:{
      data: [],
      size: 10,
      index: 1,
    },
    claimedTicketsList:{
      data: [],
      size: 10,
      index: 1,
    },
    downlineList:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    betHistory: {
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    livecasinoResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    slotResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    cockfightResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    rebateResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    sbResult:{
      data: [],
      size: 10,
      index: 1,
      working_date: ""
    },
    tempName: "",
    tempPass: "",
    tempTac: "",
    seoInfo:{
      "id": "",
      "en_page_name": "",
      "en_item_name": "",
      "en_body": "",
      "fil_page_name": "",
      "fil_item_name": "",
      "fil_body": "",
      "meta_title": "",
      "meta_desc": "",
      "meta_keywords": "",
      "meta_url": "",
      "meta_canonical": "",
      "meta_author": "",
      "meta_publisher": "",
      "meta_lang": "",
      "meta_image_url": ""
    },
    homeSeo:{
      "id": "",
      "en_page_name": "",
      "en_item_name": "",
      "en_body": "",
      "fil_page_name": "",
      "fil_item_name": "",
      "fil_body": "",
      "meta_title": "",
      "meta_desc": "",
      "meta_keywords": "",
      "meta_url": "",
      "meta_canonical": "",
      "meta_author": "",
      "meta_publisher": "",
      "meta_lang": "",
      "meta_image_url": ""
    },
    annBeforeLog: [],
    annAfterLog: [],
    refreshKey: 0,
    slotSelected: 0,
    inbox: [],
    rewards: [],
    referralCode: "",
    topten: [],
    account: "",
    balance: 0,
    gameToken: 0,
    transaction: false,
    transactionEwallet: false,
    bankList: [],
    socialList: [],
    favList:[],
    avatarImg:"",
    smarticoData:{},
    missions: 0,
    badges: 0,
    currentLevel:"",
    currentLevelDetails:{},
    nextLevelDetails:{},
    vip:""
  },
  mutations: {
    updateLanguage(state, payload) {
      state.language = payload;
    },
    uTransferDetails(state, payload) {
      state.transferDetails = payload;
    },
    uBetHistory(state, payload) {
      state.betHistory = payload;
    },
    uLivecasinoResult(state, payload) {
      state.livecasinoResult = payload;
    },
    uSlotResult(state, payload) {
      state.slotResult = payload;
    },
    uCockfightResult(state, payload) {
      state.cockfightResult = payload;
    },
    uRebateResult(state, payload){
      state.rebateResult = payload
    },
    uSbResult(state, payload){
      state.sbResult = payload
    },
    uPromoDetails(state, payload) {
      state.promoDetails = payload;
    },
    uAdjustmentDetails(state, payload) {
      state.adjustmentDetails = payload;
    },
    uRefereeCount(state, payload) {
      state.refereeCount = payload;
    },
    uDownlineList(state, payload) {
      state.downlineList = payload;
    },
    uBetList(state, payload) {
      state.betList = payload;
    },
    uClaimedTicketsList(state, payload) {
      state.claimedTicketsList = payload;
    },
    update(state, payload) {
      state.account = payload.data;
    },
    delete(state) {
      state.account = "";
      
      state.transaction = false;
      state.transactionEwallet = false;
      state.balance = 0;
      state.gameToken = 0;
      state.livecasinoResult = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.slotResult = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.cockfightResult = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.rebateResult ={
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      },
      state.sbResult ={
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      },
      state.downlineList = {
        data: [],
        size: 10,
        index: 1,
        working_date: ""
      }
      state.inbox = [];
      state.rewards = []
      state.favList = []
      state.avatarImg=""
      state.currentLevel=""
      state.vip =""
      // window.sessionStorage.clear();
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    },
    updateBalance(state, payload) {
      state.balance = payload.game_balance;
      state.gameToken = payload.game_token
      // state.account.vip_level = payload.vip_level;
    },
    updateBank(state, payload) {
      state.transaction = payload;
    },
    updateEwallet(state, payload) {
      state.transactionEwallet = payload;
    },
    updateRefreshKey(state, payload) {
      state.refreshKey = payload;
    },
    updateSlotSelected(state, payload){
      state.slotSelected = payload;
    },
    updateInbox(state, payload) {
      state.inbox = payload;
    },
    updateRewards(state, payload) {
      state.rewards = payload;
    },
    updateTopTen(state, payload) {
      state.topten = payload;
    },
    // updateIsPanel(state, payload){
    //   state.isPanel = payload
    // },
    updateTempName(state,payload){
      state.tempName = payload;
    },
    updateTempPass(state, payload){
      state.tempPass = payload
    },
    updateTempTac(state, payload){
      state.tempTac = payload
    },
    updateSeo(state, payload){
      if(payload.page_name === 'home_page'){
        state.homeSeo = payload
      }else{
        state.seoInfo = payload
      }
    },
    updateAnnBeforeLog(state, payload){
      state.annBeforeLog = payload
    },
    updateAnnAfterLog(state, payload){
      state.annAfterLog = payload
    },
    updateEmail(state, payload){
      state.account.contact_email = payload
    },
    updateUsername(state, payload){
      state.account.full_name = payload
    },
    updateSociallist(state, payload){
      state.socialList = payload
    },
    updateFavlist(state, payload){
      state.favList = payload
    },
    updateAvatar(state, payload){
      state.avatarImg = payload
    },
    updateSmarticoData(state, payload){
      state.smarticoData = payload
    },
    updateMissions(state, payload){
      state.missions = payload
    },
    updateBadges(state, payload){
      state.badges = payload
    },
    updateCurrentLevel(state, payload){
      state.currentLevel = payload
    },
    updateCurrentlvlDetails(state, payload){
      state.currentLevelDetails = payload
    },
    updateNextlvlDetails(state, payload){
      state.nextLevelDetails = payload
    },
    updateVip(state, payload){
      state.vip = payload.vip
    }
  },
  actions: {
    // updatePanel(context, payload){
    //   context.commit("updateIsPanel", payload)
    // },
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    },
    tempAccName(context,payload){
      context.commit("updateTempName", payload)
    },
    tempPass(context, payload){
      context.commit("updateTempPass", payload)
    },
    tempTac(context, payload){
      context.commit("updateTempTac", payload)
    },
    seoInfo(context,payload){
      context.commit("updateSeo", payload)
    },
    annBeforeLog(context,payload){
      context.commit("updateAnnBeforeLog", payload)
    },
    annAfterLog(context,payload){
      context.commit("updateAnnAfterLog", payload)
    },
    sTransferDetails(context, payload) {
      context.commit("uTransferDetails", payload);
    },
    sBetHistory(context, payload) {
      context.commit("uBetHistory", payload);
    },
    sLivecasinoResult(context, payload){
      context.commit("uLivecasinoResult", payload)
    },
    sSlotResult(context, payload){
      context.commit("uSlotResult", payload)
    },
    sCockfightResult(context, payload){
      context.commit("uCockfightResult", payload)
    },
    sRebateResult(context, payload){
      context.commit("uRebateResult", payload)
    },
    sSbResult(context, payload){
      context.commit("uSbResult", payload)
    },
    sPromoDetails(context, payload) {
      context.commit("uPromoDetails", payload);
    },
    sAdjustmentDetails(context, payload) {
      context.commit("uAdjustmentDetails", payload);
    },
    sRefereeCount(context, payload) {
      context.commit("uRefereeCount", payload);
    },
    sDownlineList(context, payload) {
      context.commit("uDownlineList", payload);
    },
    sBetList(context, payload) {
      context.commit("uBetList", payload);
    },
    sClaimedTicketsList(context, payload) {
      context.commit("uClaimedTicketsList", payload);
    },
    setRefreshKey(context, payload) {
      context.commit("updateRefreshKey", payload);
    },
    setSlotSelected(context, payload){
      context.commit("updateSlotSelected", payload);
    },
    setEmail(context, payload){
      context.commit("updateEmail", payload)
    },
    setAvatar(context, payload){
      context.commit("updateAvatar", payload)
    },
    setSmarticoData(context, payload){
      context.commit("updateSmarticoData", payload)
    },
    setMissions(context, payload){
      context.commit("updateMissions", payload)
    },
    setBadges(context, payload){
      context.commit("updateBadges", payload)
    },
    setCurrentLevel(context, payload){
      context.commit("updateCurrentLevel", payload)
    },
    setCurrentlvlDetails(context, payload){
      context.commit("updateCurrentlvlDetails", payload)
    },
    setNextlvlDetails(context, payload){
      context.commit("updateNextlvlDetails", payload)
    },
    login(context, user) {
      const url = config.memberLogin();
      const body = {
        account_id: user.username,
        password: user.password,
      };
      const feedback = {
        success: false,
        status: errorTags.login.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("username" in user)) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.username.length <= 0) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var sessionToken = null;
                  var data = null;
                  try {
                    sessionToken = successResponse.data.value[0].session_token;
                    data = successResponse.data.value[0];
                    
                    if (sessionToken) {
                      context.commit("update", { data });
                      // let account_id = user.username
                      // let auth_token = sessionToken
                      // let app_id = user.app_id
                      // commit("getInbox", {account_id, auth_token, app_id})
                      // dispatch('getInbox', null, { root: true })
                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorTags.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  // router.push("/").catch(err=>{});
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    forgotPassword(context, user) {
      const url = config.forgotPassword();
      const body = {
        account_id: user.account_id,
        contact_phone: user.contact_phone
      };
      const feedback = {
        success: false,
        status: errorTags.forgotPassword.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.forgotPassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.forgotPassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.forgotPassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "forgotPassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "forgotPassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.forgotPassword.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "forgotPassword",
                status: false
              });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberSignUp(context, user) {
      const url = config.membersignup();
      const body = {
        account_id: user.account_id,
        password: user.password,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email,
        referral_code: user.referral_code,
        affiliate_code: user.affiliate_code,
        fbp: user.fbp,
        pixelId: user.pixelId,
        ch: user.ch,
        cm: user.cm,
        pp: user.pp,
        domain: user.domain
        // bank_id: user.bank_id,
        // bank_acc_holder: user.bank_acc_holder,
        // bank_acc_no: user.bank_acc_no,
      };
      const feedback = {
        success: false,
        status: errorTags.memberSignUp.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberSignUp.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.memberSignUp.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (!("contact_email" in user)) {
        //   feedback.status = errorTags.memberSignUp.emailRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        // if (!("bank_id" in user)) {
        //   feedback.status = errorTags.memberAddBank.bankIdRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        // if (!("bank_acc_holder" in user)) {
        //   feedback.status = errorTags.memberAddBank.bankAccHolderRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        // if (!("bank_acc_no" in user)) {
        //   feedback.status = errorTags.memberAddBank.bankAccNoRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberSignUp.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.memberSignUp.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (user.contact_email.length <= 0) {
        //   feedback.status = errorTags.memberSignUp.emailRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        // if (user.bank_id.length <= 0) {
        //   feedback.status = errorTags.memberAddBank.bankIdRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        // if (user.bank_acc_holder.length <= 0) {
        //   feedback.status = errorTags.memberAddBank.bankAccHolderRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        // if (user.bank_acc_no.length <= 0) {
        //   feedback.status = errorTags.memberAddBank.bankAccNoRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        

        if (this.state.user._loading.memberSignUp == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberSignUp", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberSignUp",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberSignUp",
                status: false
              });
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberTacValidate(context, user) {
      const url = config.memberTacValidate();
      const body = {
        account_id: user.account_id,
        tac: user.tac,
        // contact_email: user.contact_email
      };
      const feedback = {
        success: false,
        status: errorTags.memberTacValidate.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberTacValidate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("tac" in user)) {
          feedback.status = errorTags.memberTacValidate.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberTacValidate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.tac.length <= 0) {
          feedback.status = errorTags.memberTacValidate.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberTacValidate == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "memberTacValidate",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberTacValidate",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberTacValidate",
                status: false
              });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberRenewTac(context, user) {
      const url = config.memberRenewTac();
      const body = {
        account_id: user.account_id,
      };
      const feedback = {
        success: false,
        status: errorTags.memberRenewTac.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberRenewTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberRenewTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberRenewTac == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberRenewTac", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberRenewTac",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberRenewTac",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    mbTacLogin(context, user) {
      const url = config.mbTacLogin();
      const body = {
        account_id: user.account_id,
      };
      const feedback = {
        success: false,
        status: errorTags.mbTacLogin.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.mbTacLogin.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.mbTacLogin.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.mbTacLogin == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "mbTacLogin", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "mbTacLogin",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "mbTacLogin",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    mbNewLogin(context, user) {
      const url = config.mbNewLogin();
      const body = {
        account_id: user.username,
        member_otp: user.member_otp,
      };
      const feedback = {
        success: false,
        status: errorTags.mbNewLogin.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("username" in user)) {
          feedback.status = errorTags.mbNewLogin.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("member_otp" in user)) {
          feedback.status = errorTags.mbNewLogin.otpRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.username.length <= 0) {
          feedback.status = errorTags.mbNewLogin.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_otp.length <= 0) {
          feedback.status = errorTags.mbNewLogin.otpRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.mbNewLogin == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          context.commit("loading", { action: "mbNewLogin", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "mbNewLogin", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var sessionToken = null;
                  var data = null;
                  try {
                    sessionToken = successResponse.data.value[0].session_token;
                    data = successResponse.data.value[0];
                    
                    if (sessionToken) {
                      context.commit("update", { data });
                      // let account_id = user.username
                      // let auth_token = sessionToken
                      // let app_id = user.app_id
                      // commit("getInbox", {account_id, auth_token, app_id})
                      // dispatch('getInbox', null, { root: true })
                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorTags.mbNewLogin.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.mbNewLogin.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  // router.push("/").catch(err=>{});
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBalance(context, user) {
      const url = config.getBalance();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getBalance.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getBalance == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getBalance", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getBalance", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value[0];
                    context.commit("updateBalance", feedback.data);
                    resolve(feedback);
                  } catch (error) {
                    // switch (feedback.status) {
                    //   case errorTags.session.expired:
                    //   case errorTags.session.invalidToken:
                    //   case errorTags.session.invalidSession:
                    //   case errorTags.session.inactiveAccount:
                    //     context.commit("delete");
                    //     router.push("/").catch(err => {});
                    //     break;
                    // }

                    reject(feedback);
                  }
                } else {
                  // switch (feedback.status) {
                  //   case errorTags.session.expired:
                  //   case errorTags.session.invalidToken:
                  //   case errorTags.session.invalidSession:
                  //   case errorTags.session.inactiveAccount:
                  //     context.commit("delete");
                  //     router.push("/").catch(err => {});
                  //     break;
                  // }

                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getBalance", status: false });
              // context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
              // router.push("/").catch(err => {}); 
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    bankLookUp(context, user) {
      const url = config.bankLookUp();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.bankLookUp.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (!("account_id" in user)) {
        //   feedback.status = errorTags.bankLookUp.accountIdRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }
        // if (user.account_id.length <= 0) {
        //   feedback.status = errorTags.bankLookUp.accountIdRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (this.state.user._loading.bankLookUp == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "bankLookUp", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "bankLookUp", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "bankLookUp", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberBankList(context, user) {
      const url = config.getMemberBankList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberBankList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMemberBankList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMemberBankList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberBankList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberBankList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberBankList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;
                  try {
                    if(successResponse.data.value.length > 0){
                      context.commit("updateBank", true);
                    } 
                    feedback.data = successResponse.data.value;
                    data = successResponse.data.value;
                    
                    resolve(feedback);
                                  
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberBankList", status: false });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberEwallet(context, user) {
      const url = config.getMemberEwallet();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberEwallet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMemberEwallet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMemberEwallet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberEwallet == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberEwallet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberEwallet", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;
                  try {
                    if(successResponse.data.value.length > 0){
                      context.commit("updateEwallet", true);
                    } 
                      feedback.data = successResponse.data.value;
                      data = successResponse.data.value;
                      resolve(feedback);
                                      
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberEwallet", status: false });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    activeList(context, user) {
      const url = config.activeList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.activeList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.activeList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.activeList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.activeList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "activeList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "activeList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var data = null;
                  try {
                    feedback.data = successResponse.data.value;
                    resolve(feedback);
                                  
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "activeList", status: false });
              context.commit("delete");
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBankingMode(context, user) {
      const url = config.getBankingMode();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getBankingMode.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getBankingMode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getBankingMode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getBankingMode == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getBankingMode", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getBankingMode", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getBankingMode", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRebate(context, user) {
      const url = config.getRebate();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRebate.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getRebate == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRebate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRebate", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRebate", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRebateDownline(context, user) {
      const url = config.getRebateDownline();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRebateDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRebateDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRebateDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getRebateDownline == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRebateDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRebateDownline", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRebateDownline", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRefereeList(context, user) {
      const url = config.getRefereeList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_date: user.working_date
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRefereeList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRefereeList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRefereeList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getRefereeList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRefereeList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRefereeList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRefereeList", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    claimRebate(context, user) {
      const url = config.claimRebate();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        amount: user.amount
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.claimRebate.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.claimRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.claimRebate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.claimRebate == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "claimRebate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "claimRebate", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "claimRebate", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    claimRebateDownline(context, user) {
      const url = config.claimRebateDownline();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        amount: user.amount
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.claimRebateDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.claimRebateDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.claimRebateDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.claimRebateDownline == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "claimRebateDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "claimRebateDownline", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "claimRebateDownline", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTurnoverProvider(context, user) {
      const url = config.getTurnoverProvider();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_month: user.working_month,
        search_id: user.search_id
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getTurnoverProvider.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getTurnoverProvider.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getTurnoverProvider.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getTurnoverProvider == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getTurnoverProvider", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getTurnoverProvider", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getTurnoverProvider", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSocialList(context, user) {
      const url = config.getSocialList();
      const body = {
        brand_code: "epic_cash_ph"
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getSocialList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (this.state.user._loading.getBankingMode == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getBankingMode", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getBankingMode", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body;
                    context.commit("updateSociallist", successResponse.body.value);
                    resolve(feedback);
                  } catch (error) {
                    // if (
                    //   feedback.status == errorTags.session.expired ||
                    //   feedback.status == errorTags.session.invalidSession
                    // ) {
                      // context.commit("delete");
                      // router.push("/").catch(err => {});
                    // }
                    reject(feedback);
                  }
                } else {
                  // if (
                  //   feedback.status == errorTags.session.expired ||
                  //   feedback.status == errorTags.session.invalidSession
                  // ) {
                    // context.commit("delete");
                    // router.push("/").catch(err => {});
                  // }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getBankingMode", status: false });
              // context.commit("delete");
              // router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRtplist(context, user) {
      const url = config.getRtplist();
      const body = {
        provider_code: "all"
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRtplist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (this.state.user._loading.getRtplist == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRtplist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRtplist", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    // if (
                    //   feedback.status == errorTags.session.expired ||
                    //   feedback.status == errorTags.session.invalidSession
                    // ) {
                      // context.commit("delete");
                      // router.push("/").catch(err => {});
                    // }
                    reject(feedback);
                  }
                } else {
                  // if (
                  //   feedback.status == errorTags.session.expired ||
                  //   feedback.status == errorTags.session.invalidSession
                  // ) {
                    // context.commit("delete");
                    // router.push("/").catch(err => {});
                  // }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRtplist", status: false });
              // context.commit("delete");
              // router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePassword(context, user) {
      const url = config.updatePassword();
      const body = {
        account_id: user.account_id,
        password: user.password,
        new_password: user.new_password,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.updatePassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.updatePassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updatePassword",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    profileUpdate(context, user) {
      const url = config.profileUpdate();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        full_name: user.full_name,
        contact_email: user.contact_email
      };
      
      const feedback = {
        data: [],
        success: false,
        status: errorTags.profileUpdate.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.profileUpdate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.profileUpdate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.profileUpdate == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "profileUpdate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "profileUpdate",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    context.commit("updateEmail", successResponse.body.value[0].contact_email)
                    context.commit("updateUsername", successResponse.body.value[0].full_name)
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "profileUpdate",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberAddBank(context, user) {
      const url = config.memberAddBank();
      const body = {
        account_id: user.account_id,
        bank_id: user.bank_id,
        bank_name: user.bank_name,
        bank_acc_holder: user.bank_acc_holder,
        bank_acc_no: user.bank_acc_no,
        tac: user.tac_code,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.memberAddBank.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberAddBank.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_id" in user)) {
          feedback.status = errorTags.memberAddBank.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_name" in user)) {
          feedback.status = errorTags.memberAddBank.bankNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_holder" in user)) {
          feedback.status = errorTags.memberAddBank.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_no" in user)) {
          feedback.status = errorTags.memberAddBank.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("tac_code" in user)) {
          feedback.status = errorTags.memberAddBank.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberAddBank.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_id.length <= 0) {
          feedback.status = errorTags.memberAddBank.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_name.length <= 0) {
          feedback.status = errorTags.memberAddBank.bankNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_holder.length <= 0) {
          feedback.status = errorTags.memberAddBank.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_no.length <= 0) {
          feedback.status = errorTags.memberAddBank.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.tac_code.length <= 0) {
          feedback.status = errorTags.memberAddBank.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberAddBank == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberAddBank", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberAddBank",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberAddBank",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberAddEwallet(context, user) {
      const url = config.memberAddEwallet();
      const body = {
        account_id: user.account_id,
        bank_id: user.bank_id,
        bank_acc_holder: user.bank_acc_holder,
        bank_acc_no: user.bank_acc_no,
        tac: user.tac_code,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.memberAddEwallet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberAddEwallet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_id" in user)) {
          feedback.status = errorTags.memberAddEwallet.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_holder" in user)) {
          feedback.status = errorTags.memberAddEwallet.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_no" in user)) {
          feedback.status = errorTags.memberAddEwallet.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("tac_code" in user)) {
          feedback.status = errorTags.memberAddEwallet.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberAddEwallet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_id.length <= 0) {
          feedback.status = errorTags.memberAddEwallet.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_holder.length <= 0) {
          feedback.status = errorTags.memberAddEwallet.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_no.length <= 0) {
          feedback.status = errorTags.memberAddEwallet.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.tac_code.length <= 0) {
          feedback.status = errorTags.memberAddEwallet.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberAddEwallet == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberAddEwallet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberAddEwallet",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberAddEwallet",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    setDefaultBank(context, user) {
      const url = config.setDefaultBank();
      const body = {
        account_id: user.account_id,
        bank_id: user.bank_id,
        bank_acc_no: user.bank_acc_no,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.setDefaultBank.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.setDefaultBank.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_id" in user)) {
          feedback.status = errorTags.setDefaultBank.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_no" in user)) {
          feedback.status = errorTags.setDefaultBank.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.setDefaultBank.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_id.length <= 0) {
          feedback.status = errorTags.setDefaultBank.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_no.length <= 0) {
          feedback.status = errorTags.setDefaultBank.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.setDefaultBank == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "setDefaultBank", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "setDefaultBank",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "setDefaultBank",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberBankTac(context, user) {
      const url = config.memberBankTac();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        
      };
      const feedback = {
        success: false,
        status: errorTags.memberBankTac.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.memberBankTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.memberBankTac.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberBankTac == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberBankTac", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "memberBankTac",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "memberBankTac",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    depositOfaPay(context, user) {
      const url = config.depositOfaPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.depositOfaPay.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.depositOfaPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.depositOfaPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.depositOfaPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.depositOfaPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.depositOfaPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "depositOfaPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "depositOfaPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "depositOfaPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    manualDeposit(context, user) {
      const url = config.manualDeposit();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        target_bank_id: user.target_bank_id,
        target_bank_acc_no: user.target_bank_acc_no,
        target_bank_acc_holder: user.target_bank_acc_holder,
        ref_no: user.ref_no,
        attachment_path: user.attachment_path,
        deposit_date: user.deposit_date,
        deposit_method: user.deposit_method,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token
      };
      const feedback = {
        success: false,
        status: errorTags.manualDeposit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.manualDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.manualDeposit.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_id" in user)) {
          feedback.status = errorTags.manualDeposit.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_acc_no" in user)) {
          feedback.status = errorTags.manualDeposit.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("target_bank_acc_holder" in user)) {
          feedback.status = errorTags.manualDeposit.bankAccNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("ref_no" in user)) {
          feedback.status = errorTags.manualDeposit.refNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_date" in user)) {
          feedback.status = errorTags.manualDeposit.depositDateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_method" in user)) {
          feedback.status = errorTags.manualDeposit.depositMethodRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.manualDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.manualDeposit.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_id.length <= 0) {
          feedback.status = errorTags.manualDeposit.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_acc_no.length <= 0) {
          feedback.status = errorTags.manualDeposit.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.target_bank_acc_holder.length <= 0) {
          feedback.status = errorTags.manualDeposit.bankAccNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ref_no.length <= 0) {
          feedback.status = errorTags.manualDeposit.refNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_date.length <= 0) {
          feedback.status = errorTags.manualDeposit.depositDateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_method.length <= 0) {
          feedback.status = errorTags.manualDeposit.depositMethodRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.manualDeposit == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "manualDeposit",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "manualDeposit",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "manualDeposit",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberTicketList(context, user) {
      const url = config.getMemberTicketList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberTicketList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMemberTicketList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMemberTicketList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberTicketList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberTicketList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberTicketList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberTicketList", status: false });
              // context.commit("delete");
              // router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTurnoverDownline(context, user) {
      const url = config.getTurnoverDownline();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_month: user.working_month,
        page_number: user.page_number,
        page_size: user.page_size
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getTurnoverDownline.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getTurnoverDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getTurnoverDownline.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getTurnoverDownline == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getTurnoverDownline", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getTurnoverDownline", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getTurnoverDownline", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromotionStatus(context, user) {
      const url = config.getPromotionStatus();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPromotionStatus.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getPromotionStatus.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getPromotionStatus.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getPromotionStatus == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPromotionStatus", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPromotionStatus", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPromotionStatus", status: false });
              // context.commit("delete");
              // router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addWithdrawTicket(context, user) {
      const url = config.addWithdrawTicket();
      const body = {
        account_id: user.account_id,
        withdrawal_amount: user.withdrawal_amount,
        auth_token: user.auth_token,
        bank_id:user.bank_id,
        bank_acc_no: user.bank_acc_no
      };
      const feedback = {
        success: false,
        status: errorTags.addWithdrawTicket.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.addWithdrawTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("withdrawal_amount" in user)) {
          feedback.status =
            errorTags.addWithdrawTicket.withdrawal_amount_required;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addWithdrawTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.withdrawal_amount.length <= 0) {
          feedback.status =
            errorTags.addWithdrawTicket.withdrawal_amount_required;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addWithdrawTicket == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "addWithdrawTicket",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "addWithdrawTicket",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                feedback.isFreeC = successResponse.body.isFreeC;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "addWithdrawTicket",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberTransferDetails(context, user) {
      const url = config.getMemberTransferDetails();
      const body = {
        account_id: user.account_id,
        working_date: user.working_date,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberGameResult(context, user) {
      const url = user.url
      const body = {
        account_id: user.account_id,
        working_date: user.working_date,
        page_size: user.page_size,
        page_number: user.page_number,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMemberGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMemberGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberGameResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberGameResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberGameResult", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPlatformWinLose(context, user) {
      const url = config.getPlatformWinLose();
      const body = {
        account_id: user.account_id,
        working_date: user.working_date,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberStatement(context, user) {
      const url = config.getMemberStatement();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberVip(context, user) {
      const url = config.getMemberVip();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberVip.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getMemberVip.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getMemberVip.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberVip == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberVip", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberVip", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    context.commit("updateVip", {vip:successResponse.body.value.deposit_turnover[0].vip_name})
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      // router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    // router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberVip", status: false });
              // context.commit("delete");
              // router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromoStatement(context, user) {
      const url = config.getPromoStatement();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_date: user.working_date,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },   
    getAdjustmentDetails(context, user) {
      const url = config.getAdjustmentDetails();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        working_date: user.working_date,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getStatement == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getInbox(context, user) {
      const url = config.getInboxList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        success: false,
        status: errorTags.getInbox.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getInbox.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getInbox.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.getInbox == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getInbox", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getInbox", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    context.commit("updateInbox", successResponse.data.value.inbox);
                    context.commit("updateRewards", successResponse.data.value.reward);
                    feedback.data = successResponse.body.value;
                    // context.commit("updateInbox", successResponse.data.value.inbox);
                    // feedback.data = successResponse.body.value.reward;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      // router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    // router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                // router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getInbox", status: false });
              // context.commit("delete");
              // router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    claimInbox(context, user) {
      const url = config.inboxClaim();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        inbox_id: user.inbox_id
      };
      const feedback = {
        success: false,
        status: errorTags.claimInbox.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.claimInbox.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.claimInbox.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("inbox_id" in user)) {
          feedback.status = errorTags.claimInbox.bonusIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.claimInbox.bonusIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.claimInbox == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "claimInbox", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "claimInbox",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // store.dispatch("user/getBalance", user);
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "claimInbox",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getQuestion(context, user) {
      const url = config.getSurveyQuestion();
      const body = {
        op: user.comp
      };
      const feedback = {
        success: false,
        status: errorTags.getQuestion.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getQuestion == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getQuestion",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getQuestion",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data= successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getQuestion",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    submitReview(context, user) {
      const url = config.memberReview();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        json_rating: user.json_rating,
        comment: user.comment,
        recipient_no: user.recipient_no
      };
      const feedback = {
        success: false,
        status: errorTags.submitReview.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.submitReview.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.submitReview.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (!("recipient_no" in user)) {
        //   feedback.status = errorTags.submitReview.recipientIdRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        // if (user.recipient_no.length <= 0) {
        //   feedback.status = errorTags.submitReview.recipientIdRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (!("comment" in user)) {
          feedback.status = errorTags.submitReview.commentRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.comment.length <= 0) {
          feedback.status = errorTags.submitReview.commentRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("json_rating" in user)) {
          feedback.status = errorTags.submitReview.ratingRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.json_rating.length <= 0) {
          feedback.status = errorTags.submitReview.ratingRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.submitReview == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "submitReview",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "submitReview",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data= successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "submitReview",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSurveyList(context, user) {
      const url = config.getTopTenReview();
      const body = {
        op: user.comp,
      };
      const feedback = {
        success: false,
        status: errorTags.getSurveyList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSurveyList == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getSurveyList",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getSurveyList",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data= successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getSurveyList",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },

    depositTracker(context, user) {
      const url = config.depositTracker();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.depositTracker.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.depositTracker.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.depositTracker.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.depositTracker == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "depositTracker", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "depositTracker", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "depositTracker", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    depositTrackerv2(context, user) {
      const url = config.depositTrackerv2();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.depositTrackerv2.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.depositTrackerv2.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.depositTrackerv2.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.depositTrackerv2 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "depositTrackerv2", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "depositTrackerv2", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "depositTrackerv2", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },

    mayaPay(context, user) {
      const url = config.mayaPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.mayaPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.mayaPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.mayaPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.mayaPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.mayaPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.mayaPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "mayaPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "mayaPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_mayapay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "mayaPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    htPay(context, user) {
      const url = config.htPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        payment_type: user.option,
        mode:user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.htPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.htPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.htPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.htPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.htPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.htPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "htPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "htPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "htPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    aiPay(context, user) {
      const url = config.aiPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        return_url: user.return_url,
        bank_code: user.bank_code,
        mode: user.mode,
        payment_type: user.option
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.aiPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.aiPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.aiPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.aiPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.aiPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.aiPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "aiPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "aiPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    // console.log(successResponse);return;
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "aiPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    rmPay(context, user) {
      const url = config.rmPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        payment_type: user.option,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.rmPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.rmPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.rmPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.rmPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.rmPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.rmPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "rmPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "htPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "rmPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    gopayGcash(context, user) {
      const url = config.gopayGcash();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        payment_type: user.option,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.gopayGcash.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.gopayGcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.gopayGcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.gopayGcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.gopayGcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.gopayGcash == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "gopayGcash", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "gopayGcash",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "gopayGcash",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    gopayMaya(context, user) {
      const url = config.gopayMaya();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.gopayMaya.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.gopayMaya.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.gopayMaya.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.gopayMaya.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.gopayMaya.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.gopayMaya == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "gopayMaya", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "gopayMaya",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "gopayMaya",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    dgpayGcash(context, user) {
      const url = config.dgpayGcash();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        mode: user.mode,
        auth_token: user.auth_token,
        return_url: user.return_url,
        payment_type: user.payment_type
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.dgpayGcash.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.dgpayGcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.dgpayGcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.dgpayGcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.dgpayGcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.dgpayGcash == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "dgpayGcash", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "dgpayGcash",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "dgpayGcash",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    dgpayGcashqr(context, user) {
      const url = config.dgpayGcashqr();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        mode: user.mode,
        auth_token: user.auth_token,
        return_url: user.return_url,
        payment_type: user.payment_type
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.dgpayGcashqr.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.dgpayGcashqr.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.dgpayGcashqr.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.dgpayGcashqr.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.dgpayGcashqr.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.dgpayGcashqr == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "dgpayGcashqr", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "dgpayGcashqr",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "dgpayGcashqr",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    dgpayMaya(context, user) {
      const url = config.dgpayMaya();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        mode: user.mode,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.dgpayMaya.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.dgpayMaya.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.dgpayMaya.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.dgpayMaya.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.dgpayMaya.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.dgpayMaya == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "dgpayMaya", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "dgpayMaya",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "dgpayMaya",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    cloudPay(context, user) {
      const url = config.cloudPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.cloudPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.cloudPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.cloudPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.cloudPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.cloudPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.cloudPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "cloudPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "cloudPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "cloudPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    topPay(context, user) {
      const url = config.topPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.topPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.topPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.topPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.topPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.topPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.topPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "topPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "topPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "topPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    anfuPay(context, user) {
      const url = config.anfuPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.anfuPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.anfuPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.anfuPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.anfuPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.anfuPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.anfuPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "anfuPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "anfuPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "anfuPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    shunfapayGcash(context, user) {
      const url = config.shunfapayGcash();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.shunfapayGcash.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.shunfapayGcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.shunfapayGcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.shunfapayGcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.shunfapayGcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.shunfapayGcash == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "shunfapayGcash", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "shunfapayGcash",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "shunfapayGcash",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    shunfapayMaya(context, user) {
      const url = config.shunfapayMaya();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.shunfapayMaya.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.shunfapayMaya.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.shunfapayMaya.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.shunfapayMaya.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.shunfapayMaya.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.shunfapayMaya == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "shunfapayMaya", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "shunfapayMaya",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "shunfapayMaya",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    worldPay(context, user) {
      const url = config.worldPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        return_url: user.return_url,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.worldPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.worldPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.worldPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.worldPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.worldPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.worldPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "worldPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "worldPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "worldPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    rgPay(context, user) {
      const url = config.rgPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        return_url: user.return_url,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.rgPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.rgPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.rgPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.rgPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.rgPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.rgPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "rgPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "rgPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "rgPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    wcPay(context, user) {
      const url = config.wcPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        payment_type: user.payment_type,
        return_url: user.return_url,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.wcPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.wcPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.wcPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.wcPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.wcPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.wcPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "wcPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "wcPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "wcPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    goldPay(context, user) {
      const url = config.goldPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        // return_url: user.return_url,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.goldPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.goldPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.goldPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.goldPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.goldPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.goldPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "goldPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "goldPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "goldPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    xftgCash(context, user) {
      const url = config.xftgCash();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        // return_url: user.return_url,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.xftgCash.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.xftgCash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.xftgCash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.xftgCash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.xftgCash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.xftgCash == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "xftgCash", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "xftgCash",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "xftgCash",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    xftUsdt(context, user) {
      const url = config.xftUsdt();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        // return_url: user.return_url,
        mode: user.mode
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.xftUsdt.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.xftUsdt.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.xftUsdt.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.xftUsdt.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.xftUsdt.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.xftUsdt == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "xftUsdt", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "xftUsdt",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "xftUsdt",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    masayaPay(context, user) {
      const url = config.masayaPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        mode: user.mode
      };
      
      const feedback = {
        data: [],
        success: false,
        status: errorTags.masayaPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.masayaPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.masayaPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.masayaPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.masayaPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.masayaPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "masayaPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "masayaPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "masayaPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    xyPay(context, user) {
      const url = config.xyPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url,
        payment_type: user.payment_type
      };
      
      const feedback = {
        data: [],
        success: false,
        status: errorTags.xyPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.xyPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.xyPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.xyPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.xyPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.xyPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "xyPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "xyPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "xyPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    tygPay(context, user) {
      const url = config.tygPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        is_mobile: user.is_mobile,
        mode: user.mode,
        return_url: user.return_url,
        bank_code: user.bank_code
      };
      
      const feedback = {
        data: [],
        success: false,
        status: errorTags.tygPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.tygPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.tygPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.tygPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.tygPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.tygPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "tygPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "tygPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "tygPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    ctPay(context, user) {
      const url = config.ctPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url,
        payment_type: user.payment_type
      };
      
      const feedback = {
        data: [],
        success: false,
        status: errorTags.ctPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.ctPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.ctPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.ctPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.ctPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.ctPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "ctPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "ctPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "ctPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    innPay(context, user) {     
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        method: user.method,
        mode: user.mode,
        return_url: user.return_url,
      };
      
      if(body.method === "INNPAYD0S"){
        var url = config.innpayD0s();
      }else if(body.method === "INNPAYD0C"){
        var url = config.innpayD0c();
      }else{
        var url = config.innpayMaya();
      }
      const feedback = {
        data: [],
        success: false,
        status: errorTags.innPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.innPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.innPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.innPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.innPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.innPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "innPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "innPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "innPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    rkPay(context, user) {
      const url = config.rkPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        // bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.rkPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.rkPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.rkPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.rkPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.rkPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.rkPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "rkPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "rkPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "rkPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    ezPay(context, user) {
      const url = config.ezPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        // bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.ezPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.ezPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.ezPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.ezPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.ezPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.ezPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "ezPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "ezPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "ezPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    sgPay(context, user) {
      const url = config.sgPay();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        // bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.sgPay.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.sgPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.sgPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.sgPay.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.sgPay.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.sgPay == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "sgPay", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "sgPay",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "sgPay",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    goldPay2(context, user) {
      const url = config.goldPay2();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.goldPay2.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.goldPay2.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.goldPay2.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.goldPay2.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.goldPay2.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.goldPay2 == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "goldPay2", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "goldPay2",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "goldPay2",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    rkPaygcash(context, user) {
      const url = config.rkPaygcash();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        // bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.rkPaygcash.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.rkPaygcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.rkPaygcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.rkPaygcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.rkPaygcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.rkPaygcash == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "rkPaygcash", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "rkPaygcash",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "rkPaygcash",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    rkPaygcashQr(context, user) {
      const url = config.rkPaygcashQr();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        // bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.rkPaygcashQr.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.rkPaygcashQr.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.rkPaygcashQr.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.rkPaygcashQr.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.rkPaygcashQr.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.rkPaygcashQr == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "rkPaygcashQr", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "rkPaygcashQr",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "rkPaygcashQr",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    swPaygcash(context, user) {
      const url = config.swPaygcash();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        // bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.swPaygcash.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.swPaygcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.swPaygcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.swPaygcash.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.swPaygcash.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.swPaygcash == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "swPaygcash", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "swPaygcash",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "swPaygcash",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    swPaygcashQr(context, user) {
      const url = config.swPaygcashQr();
      const body = {
        account_id: user.account_id,
        deposit_amount: user.deposit_amount,
        promotion_id: user.promotion_id,
        auth_token: user.auth_token,
        // bank_code: user.bank_code,
        mode: user.mode,
        return_url: user.return_url
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.swPaygcashQr.failed
      };
      
      return new Promise((resolve, reject) => {
        var canRequest = true;
        
        if (!("account_id" in user)) {
          feedback.status = errorTags.swPaygcashQr.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("deposit_amount" in user)) {
          feedback.status = errorTags.swPaygcashQr.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.swPaygcashQr.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.deposit_amount.length <= 0) {
          feedback.status = errorTags.swPaygcashQr.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.swPaygcashQr == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "swPaygcashQr", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "swPaygcashQr",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.pg_htpay_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "swPaygcashQr",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCouponDetails(context, user) {
      const url = config.getCouponDetails();
      const body = {
        account_id: user.account_id,
        coupon_code: user.coupon_code,
        auth_token: user.auth_token,
        app_id: user.app_id
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getCouponDetails.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getCouponDetails.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getCouponDetails.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (this.state.user._loading.getCouponDetails == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getCouponDetails", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getCouponDetails",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getCouponDetails",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updateEmail(context, user) {
      const url = config.updateEmail();
      const body = {
        app_id: user.app_id,
        account_id: user.account_id,
        auth_token: user.auth_token,
        contact_email: user.contact_email
      };
      const feedback = {
        success: false,
        status: errorTags.updateEmail.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.updateEmail.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_id.length <= 0) {
          feedback.status = errorTags.updateEmail.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("contact_email" in user)) {
          feedback.status = errorTags.updateEmail.emailRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.contact_email.length <= 0) {
          feedback.status = errorTags.updateEmail.emailRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updateEmail == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "updateEmail",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "updateEmail",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "updateEmail",
                status: false
              });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchEpic(context, user) {
      const url = config.launchEpic();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchEpic.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchEpic.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchEpic.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchEpic == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchEpic", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchEpic", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchEpic", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchEpic2(context, user) {
      const url = config.launchEpic2();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchEpic2.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchEpic2.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchEpic2.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchEpic2 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchEpic2", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchEpic2", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchEpic2", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchHabaneroDemo(context, user) {
      const url = config.launchHabaneroDemo();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchHabaneroDemo.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchHabaneroDemo.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchHabaneroDemo.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        // if (this.state.user._loading.launchHabaneroDemo == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchHabaneroDemo", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchHabaneroDemo", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_demo_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchHabaneroDemo", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchLive22(context, user) {
      const url = config.launchLive22();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchLive22.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchLive22.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchLive22.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchLive22 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchLive22", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchLive22", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchLive22", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },

    launchAwc(context, user) {
      const url = config.launchAwc();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        game_type: user.game_type,
        provider: user.provider,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchAwc.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchAwc.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchAwc.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchAwc == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchAwc", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchAwc", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "SUCCESS";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchAwc", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchJili(context, user) {
      const url = config.launchJili();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchJili.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchJili.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchJili.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchJili == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchJili", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchJili", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchJili", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchFc(context, user) {
      const url = config.launchFc();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchFc.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchFc.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchFc.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchFc == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchFc", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchFc", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "SUCCESS";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchFc", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchSabong(context, user) {
      const url = config.launchSabong();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchSabong.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchSabong.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchSabong.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchSabong == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchSabong", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchSabong", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchSabong", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchIronclaw(context, user) {
      const url = config.launchIronclaw();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchIronclaw.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchIronclaw.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchIronclaw.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchIronclaw == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchIronclaw", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchIronclaw", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchIronclaw", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchEvo(context, user) {
      const url = config.launchEvo();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        mobile: user.mobile,
        game_code: user.game_code,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchEvo.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchEvo.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchEvo.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchEvo == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchEvo", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchEvo", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "SUCCESS";
                } else {
                  feedback.success = successResponse.body.status == "SUCCESS";
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchEvo", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchCq9(context, user) {
      const url = config.launchCq9();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        game_code: user.game_code,
        game_name: user.game_name,
        platform: user.platform
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchCq9.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchCq9.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchCq9.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchCq9 == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchCq9", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchCq9", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchCq9", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchHabanero(context, user) {
      const url = config.launchHabanero();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchHabanero.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchHabanero.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchHabanero.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchHabanero == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchHabanero", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchHabanero", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchHabanero", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchPps(context, user) {
      const url = config.launchPps();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        game_code: user.game_code,
        lang_code: user.lang_code,
        game_name: user.game_name
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchPps.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchPps.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchPps.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchPps == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchPps", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchPps", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchPps", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchPpc(context, user) {
      const url = config.launchPpc();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchPpc.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchPpc.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchPpc.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchPpc == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchPpc", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchPpc", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchPpc", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchLaunchOne(context, user) {
      const url = config.launchLaunchOne();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        game_code: user.game_code,
        provider: user.provider,
        platform: user.platform
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchLaunchOne.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchLaunchOne.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchLaunchOne.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchLaunchOne == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchLaunchOne", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchLaunchOne", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                // feedback.status = successResponse.body.status;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchLaunchOne", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchYgr(context, user) {
      const url = config.launchYgr();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        game_code: user.game_code,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchYgr.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchYgr.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchYgr.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchYgr == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchYgr", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchYgr", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                // feedback.status = successResponse.body.status;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchYgr", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchWow(context, user) {
      const url = config.launchWow();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        // game_code: user.game_code,
        // provider: user.provider,
        // platform: user.platform
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchWow.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchWow.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchWow.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchWow == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchWow", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchWow", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                // feedback.status = successResponse.body.status;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchWow", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchOpenapi(context, user) {
      const url = config.launchOpenapi();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        game_code: user.game_code,
        provider: user.provider,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchOpenapi.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchOpenapi.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchOpenapi.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchOpenapi == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchOpenapi", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchOpenapi", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                // feedback.status = successResponse.body.status;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchOpenapi", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchTbl(context, user) {
      const url = config.launchTbl();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        lang_code: user.lang_code,
        game_code: user.game_code,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchTbl.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchTbl.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchTbl.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchTbl == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchTbl", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchTbl", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                // feedback.status = successResponse.body.status;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    feedback.lobby = successResponse.body.game_lobby_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchTbl", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    launchWbet(context, user) {
      const url = config.launchWbet();
      const body = {
        player_id: user.player_id,
        auth_token: user.auth_token,
        type: user.type,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.launchWbet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.launchWbet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.launchWbet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.launchWbet == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "launchWbet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "launchWbet", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.game_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "launchWbet", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getLive22Result(context, user) {
      const url = config.getLive22Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getLive22Result.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getLive22Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getLive22Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getLive22Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getLive22Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getLive22Result == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getLive22Result", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getLive22Result", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getLive22Result", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getEpic2Result(context, user) {
      const url = config.getEpic2Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getEpic2Result.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getEpic2Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getEpic2Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getEpic2Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getEpic2Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getEpic2Result == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getEpic2Result", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getEpic2Result", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getEpic2Result", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getCq9Result(context, user) {
      const url = config.getCq9Result();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getCq9Result.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getCq9Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getCq9Result.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getCq9Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getCq9Result.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getCq9Result == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getCq9Result", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getCq9Result", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getCq9Result", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getHabaneroResult(context, user) {
      const url = config.getHabaneroResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
        lang_code: user.lang_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getHabaneroResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getHabaneroResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getHabaneroResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getHabaneroResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getHabaneroResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getHabaneroResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getHabaneroResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getHabaneroResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getHabaneroResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPpsResult(context, user) {
      const url = config.getPpsResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPpsResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getPpsResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getPpsResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getPpsResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getPpsResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getPpsResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPpsResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPpsResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPpsResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPpcResult(context, user) {
      const url = config.getPpcResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPpcResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getPpcResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getPpcResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getPpcResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getPpcResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getPpcResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPpcResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPpcResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPpcResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAwcResult(context, user) {
      const url = config.getAwcResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getAwcResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getAwcResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getAwcResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getAwcResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getAwcResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getAwcResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getAwcResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getAwcResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getAwcResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getJiliResult(context, user) {
      const url = config.getJiliResult();
      const body = {
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getJiliResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getJiliResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getJiliResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getJiliResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getJiliResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getJiliResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getJiliResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getJiliResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getJiliResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getLaunchoneResult(context, user) {
      const url = config.getLaunchoneResult();
      const body = {
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getLaunchoneResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getLaunchoneResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getLaunchoneResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getLaunchoneResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getLaunchoneResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getLaunchoneResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getLaunchoneResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getLaunchoneResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getLaunchoneResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getYgrResult(context, user) {
      const url = config.getYgrResult();
      const body = {
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getYgrResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getYgrResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getYgrResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getYgrResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getYgrResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getYgrResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getYgrResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getYgrResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getYgrResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getWowResult(context, user) {
      const url = config.getWowResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getWowResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getWowResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getWowResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getWowResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getWowResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getWowResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getWowResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getWowResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getWowResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getWowResult(context, user) {
      const url = config.getWowResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getWowResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getWowResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getWowResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getWowResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getWowResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getWowResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getWowResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getWowResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getWowResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getOpenapiResult(context, user) {
      const url = config.getOpenapiResult();
      const body = {
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getOpenapiResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getOpenapiResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getOpenapiResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getOpenapiResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getOpenapiResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getOpenapiResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getOpenapiResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getOpenapiResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getOpenapiResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getFcResult(context, user) {
      const url = config.getFcResult();
      const body = {
        player_id: user.player_id,
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getFcResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("player_id" in user)) {
          feedback.status = errorTags.getFcResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.player_id.length <= 0) {
          feedback.status = errorTags.getFcResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getFcResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getFcResult
          canRequest = false;
        }

        // if (this.state.user._loading.getFcResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getFcResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getFcResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getFcResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getEvoResult(context, user) {
      const url = config.getEvoResult();
      const body = {
        ticket_id: user.ticket_id,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getEvoResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("ticket_id" in user)) {
          feedback.status = errorTags.getEvoResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.ticket_id.length <= 0) {
          feedback.status = errorTags.getEvoResult.resultIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getEvoResult == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getEvoResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getEvoResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.status_desc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.detail_url;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getEvoResult", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    // getEpicResult(context, user) {
    //   const url = config.getEpicResult();
    //   const body = {
    //     player_id: user.player_id,
    //     ticket_id: user.ticket_id,
    //     lang_code: user.lang_code
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.getEpicResult.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("player_id" in user)) {
    //       feedback.status = errorTags.getEpicResult.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.player_id.length <= 0) {
    //       feedback.status = errorTags.getEpicResult.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     if (!("ticket_id" in user)) {
    //       feedback.status = errorTags.getEpicResult.resultIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.ticket_id.length <= 0) {
    //       feedback.status = errorTags.getEpicResult.resultIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     // if (this.state.user._loading.getEpicResult == true) {
    //     //   feedback.status = errorTags.request.processing;
    //     //   canRequest = false;
    //     // }

    //     if (canRequest == true) {
    //       // context.commit("loading", { action: "getEpicResult", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           // context.commit("loading", { action: "getEpicResult", status: false });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.status_desc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.detail_url;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   // context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 // context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             // context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           // context.commit("loading", { action: "getEpicResult", status: false });
    //           // context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // getWorldcupTicket(context, user) {
    //   const url = config.getWorldcupTicket();
    //   const body = {
    //     account_id: user.account_id,
    //     auth_token: user.auth_token,
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.getWorldcupTicket.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.getWorldcupTicket.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.getWorldcupTicket.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     // if (this.state.user._loading.getWorldcupTicket == true) {
    //     //   feedback.status = errorTags.request.processing;
    //     //   canRequest = false;
    //     // }

    //     if (canRequest == true) {
    //       // context.commit("loading", { action: "getWorldcupTicket", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           // context.commit("loading", { action: "getWorldcupTicket", status: false });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.value;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           // context.commit("loading", { action: "getWorldcupTicket", status: false });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // claimWorldcupTicket(context, user) {
    //   const url = config.claimWorldcupTicket();
    //   const body = {
    //     account_id: user.account_id,
    //     auth_token: user.auth_token,
    //     ticket_count: user.ticket_count
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.claimWorldcupTicket.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.claimWorldcupTicket.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (!("ticket_count" in user)) {
    //       feedback.status = errorTags.claimWorldcupTicket.ticketAmountRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.claimWorldcupTicket.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     // if (this.state.user._loading.claimWorldcupTicket == true) {
    //     //   feedback.status = errorTags.request.processing;
    //     //   canRequest = false;
    //     // }

    //     if (canRequest == true) {
    //       // context.commit("loading", { action: "claimWorldcupTicket", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           // context.commit("loading", { action: "claimWorldcupTicket", status: false });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.value;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           // context.commit("loading", { action: "claimWorldcupTicket", status: false });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // getWorldcupList(context, user) {
    //   const url = config.getWorldcupList();
    //   const body = {
    //     account_id: user.account_id,
    //     auth_token: user.auth_token,
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.getWorldcupList.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.getWorldcupList.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.getWorldcupList.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     // if (this.state.user._loading.getWorldcupList == true) {
    //     //   feedback.status = errorTags.request.processing;
    //     //   canRequest = false;
    //     // }

    //     if (canRequest == true) {
    //       // context.commit("loading", { action: "getWorldcupList", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           // context.commit("loading", { action: "getWorldcupList", status: false });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.value;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           // context.commit("loading", { action: "getWorldcupList", status: false });
    //           context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    // getWorldcupResult(context, user) {
    //   const url = config.getWorldcupResult();
    //   const body = {
    //     account_id: user.account_id,
    //     auth_token: user.auth_token,
    //   };
    //   const feedback = {
    //     data: [],
    //     success: false,
    //     status: errorTags.getWorldcupResult.failed
    //   };

    //   return new Promise((resolve, reject) => {
    //     var canRequest = true;

    //     if (!("account_id" in user)) {
    //       feedback.status = errorTags.getWorldcupResult.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }
    //     if (user.account_id.length <= 0) {
    //       feedback.status = errorTags.getWorldcupResult.accountIdRequired;
    //       reject(feedback);
    //       canRequest = false;
    //     }

    //     // if (this.state.user._loading.getWorldcupResult == true) {
    //     //   feedback.status = errorTags.request.processing;
    //     //   canRequest = false;
    //     // }

    //     if (canRequest == true) {
    //       // context.commit("loading", { action: "getWorldcupResult", status: true });
    //       Vue.http.post(url, body).then(
    //         successResponse => {
    //           // context.commit("loading", { action: "getWorldcupResult", status: false });
    //           if (successResponse) {
    //             if (typeof successResponse.body.status == "string") {
    //               feedback.success = successResponse.body.status == "1";
    //             } else {
    //               feedback.success = successResponse.body.status == 1;
    //             }
    //             feedback.status = successResponse.body.statusdesc;
    //             if (feedback.success == true) {
    //               try {
    //                 feedback.data = successResponse.body.value;
    //                 resolve(feedback);
    //               } catch (error) {
    //                 if (
    //                   feedback.status == errorTags.session.expired ||
    //                   feedback.status == errorTags.session.invalidSession
    //                 ) {
    //                   // context.commit("delete");
    //                   router.push("/").catch(err => {});
    //                 }
    //                 reject(feedback);
    //               }
    //             } else {
    //               if (
    //                 feedback.status == errorTags.session.expired ||
    //                 feedback.status == errorTags.session.invalidSession
    //               ) {
    //                 // context.commit("delete");
    //                 router.push("/").catch(err => {});
    //               }
    //               reject(feedback);
    //             }
    //           } else {
    //             // Response is empty...
    //             // context.commit("delete");
    //             router.push("/").catch(err => {});
    //             reject(feedback);
    //           }
    //         },
    //         errorResponse => {
    //           // context.commit("loading", { action: "getWorldcupResult", status: false });
    //           // context.commit("delete");
    //           router.push("/").catch(err => {});
    //           feedback.status = errorResponse;
    //           reject(feedback);
    //         }
    //       );
    //     } else {
    //       reject(feedback);
    //     }
    //   });
    // },
    makeBet(context, user) {
      const url = config.makeBet();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        match_id: user.match_id,
        home_score: user.home_score,
        away_score: user.away_score
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.makeBet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.makeBet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.makeBet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.makeBet == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "makeBet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "makeBet", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "makeBet", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getBetList(context, user) {
      const url = config.getBetList();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        page_size: user.page_size,
        page_number: user.page_number
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getBetList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getBetList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getBetList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getBetList == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getBetList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getBetList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getBetList", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getClaimedTickets(context, user) {
      const url = config.getClaimedTickets();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        page_size: user.page_size,
        page_number: user.page_number
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getClaimedTickets.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getClaimedTickets.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getClaimedTickets.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getClaimedTickets == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getClaimedTickets", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getClaimedTickets", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getClaimedTickets", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRebateChart(context, user) {
      const url = config.getRebateChart();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRebateChart.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getRebateChart.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getRebateChart.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getRebateChart == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRebateChart", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRebateChart", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRebateChart", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getXchangeRate(context, user) {
      const url = config.getXchangeRate();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getXchangeRate.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getXchangeRate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getXchangeRate.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getXchangeRate == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getXchangeRate", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getXchangeRate", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getXchangeRate", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getStreamLink(context, user) {
      const url = config.getStreamLink();
      const body = {
        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStreamLink.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (canRequest == true) {
          // context.commit("loading", { action: "getStreamLink", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getStreamLink", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getStreamLink", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTopgame(context, user) {
      const url = config.getTopgame();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getTopgame.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getTopgame.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getTopgame.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getTopgame == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getTopgame", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getTopgame", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getTopgame", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromoDepositCount(context, user) {
      const url = config.getPromoDepositCount();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        promotion_id : user.promotion_id
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPromoDepositCount.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getPromoDepositCount.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getPromoDepositCount.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          // context.commit("loading", { action: "getPromoDepositCount", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPromoDepositCount", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getPromoDepositCount", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getRealTimeTrans(context, user) {
      const url = config.getRealTimeTrans();
      const body = {
        method: user.method
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getRealTimeTrans.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        // if (this.state.user._loading.getRealTimeTrans == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getRealTimeTrans", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getRealTimeTrans", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      // context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    // context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                // context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getRealTimeTrans", status: false });
              // context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getProviderGameOfflist(context, user) {
      const url = config.getProviderGameOfflist();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        provider_code: user.provider_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getProviderGameOfflist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getProviderGameOfflist.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getProviderGameOfflist.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("provider_code" in user)) {
          feedback.status = errorTags.getProviderGameOfflist.providerRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.provider_code.length <= 0) {
          feedback.status = errorTags.getProviderGameOfflist.providerRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getProviderGameOfflist == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getProviderGameOfflist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getProviderGameOfflist", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getProviderGameOfflist", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTokenBalance(context, user) {
      const url = config.getTokenBalance();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getTokenBalance.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getTokenBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getTokenBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getTokenBalance == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getTokenBalance", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getTokenBalance", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getTokenBalance", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    

    /* cms */
    getSlideBanner(context, user) {
      const url = config.getSlideBanner();
      const body = {
        lang: "all"
      };
      const feedback = {
        success: false,
        status: errorTags.getSlideBanner.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSlideBanner == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getSlideBanner", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getSlideBanner", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAnnBanner(context, user) {
      const url = config.getAnnBanner();
      const body = {
        lang: "all"
      };
      const feedback = {
        success: false,
        status: errorTags.getAnnBanner.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getAnnBanner == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getAnnBanner", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getAnnBanner", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    var annBeforeLogList = []
                    var annAfterLogList = []
                    if(successResponse.body.value.length > 0){
                      successResponse.body.value.forEach(x => {
                        if(x.banner_type === 1){
                          annBeforeLogList.push(x)
                        }else{
                          annAfterLogList.push(x)
                        }
                      })
                    }
                    if(annBeforeLogList.length > 0){
                      feedback.annBeforeLog = true
                      context.commit("updateAnnBeforeLog", annBeforeLogList);
                    }
                    if(annAfterLogList.length > 0){
                      feedback.annAfterLog = true
                      context.commit("updateAnnAfterLog", annAfterLogList);
                    }
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromoBanner(context, user) {
      const url = config.getPromoBanner();
      const body = {
        lang: "all"
      };
      const feedback = {
        success: false,
        status: errorTags.getPromoBanner.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getPromoBanner == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getPromoBanner", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getPromoBanner", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getSeo(context, user) {
      const url = config.getSeo();
      const body = {
        page_name: user.page_name
      };
      const feedback = {
        success: false,
        status: errorTags.getSeo.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getSeo == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          // context.commit("loading", { action: "getSeo", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getSeo", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    reject(feedback);
                  }
                } else {
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },

    /* fav list  */
    getFavlist(context, user) {
      const url = config.getFavlist();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getFavlist.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.getFavlist.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getFavlist.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getFavlist == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getFavlist", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getFavlist", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    context.commit("updateFavlist", successResponse.body.value);
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getFavlist", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addFav(context, user) {
      const url = config.addFav();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        provider_code: user.provider_code,
        game_code: user.game_code,
        game_name: user.game_name,
        game_type: user.game_type,
        img_url: user.img_url,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.addFav.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.addFav.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addFav.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.addFav == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "addFav", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "addFav", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "addFav", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    removeFav(context, user) {
      const url = config.removeFav();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        provider_code: user.provider_code,
        game_code: user.game_code
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.removeFav.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.removeFav.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.removeFav.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.removeFav == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "removeFav", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "removeFav", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    context.commit("updateFavlist", successResponse.body.value);
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "removeFav", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },


    /* event */
    pickiconCampaign(context, user) {
      const url = config.pickiconCampaign();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token,
        icon: user.icon
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.pickiconCampaign.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.pickiconCampaign.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.pickiconCampaign.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.pickiconCampaign == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "pickiconCampaign", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "pickiconCampaign", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "pickiconCampaign", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },

    pickiconcampaignCheck(context, user) {
      const url = config.pickiconcampaignCheck();
      const body = {
        account_id: user.account_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.pickiconcampaignCheck.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in user)) {
          feedback.status = errorTags.pickiconcampaignCheck.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.pickiconcampaignCheck.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.pickiconcampaignCheck == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "pickiconcampaignCheck", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "pickiconcampaignCheck", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "pickiconcampaignCheck", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
  }
};
